import { Route,Routes } from "react-router-dom";
import Home from "./Home/Home";
import Footer from "./Footer/Footer";
import Header from "./Header/Header";
import About from "./About/About";
import BookDemo from "./BookDemo/BookDemo";
import Portfolio from "./Portfolio/Portfolio";
import Layout from "../ Layout";
import Service from "./Service/Service";
import Product from "./Product/Product";
import PortfolioDetail from "./Portfolio/PortfolioDetail";
import Privacy from "./Footer/Privacy";
import TermsConditions from "./Footer/TermsConditions";

function Main() {
    return(
        <div className="Main">
            <Header/>
            <Layout>
    <Routes>
      
      <Route path="/"  element={<Home/>}/>
      <Route path="/about"  element={<About/>}/>
      <Route path="/book" element={<BookDemo/>}/>
      <Route path="/portfolio" element={<Portfolio/>}/>
      <Route path="/service" element={<Service/>}/>
      <Route path="/product" element={<Product/>}/>
      <Route path="/portfolio/:id" element={<PortfolioDetail />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<TermsConditions />} />

     </Routes>
  </Layout>
   <Footer/>
        </div>

    )
}
export default Main;